import './AnimatedHeroTitle.css';

function AnimatedHeroTitle() {
  const text = 'VW TECH';

  return (
    <h1 className="animated-hero-title">
      {text.split('').map((char, idx) => (
        <span key={idx} className="char">
          {char === ' ' ? '\u00A0' : char}
        </span>
      ))}
    </h1>
  );
}

export default AnimatedHeroTitle;
